/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { GetTransitionAuthorisationResponse } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class TransitionAuthorisationV1Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags transition-authorisation-v-1-controller
   * @name PerformAction1
   * @request POST:/api/v1/transition-authorisation/{id}/action/{authorisationAllowedAction}
   */
  performAction = (
    id: string,
    authorisationAllowedAction: 'AUTHORISE' | 'REJECT' | 'WITHDRAW',
    params: RequestParams = {},
  ) =>
    this.http.request<GetTransitionAuthorisationResponse, any>({
      path: `/v1/transition-authorisation/${id}/action/${authorisationAllowedAction}`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static performActionPath =
    '/v1/transition-authorisation/${id}/action/${authorisationAllowedAction}'
  static performActionMethod = 'POST'
  /**
   * No description
   *
   * @tags transition-authorisation-v-1-controller
   * @name GetById7
   * @request GET:/api/v1/transition-authorisation/{id}
   */
  getById = (id: string, params: RequestParams = {}) =>
    this.http.request<GetTransitionAuthorisationResponse, any>({
      path: `/v1/transition-authorisation/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdPath = '/v1/transition-authorisation/${id}'
  static getByIdMethod = 'GET'
}
